"use client";

import AppraisalFormPage from "../../pages/AppraisalFormPage";

export default function AppraisalRoutePage() {
  return <AppraisalFormPage />;
}
